import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    pageMeta: any = {
        pageNum: 1,
        pageSize: 10,
        pages: 0,
        total: 0,
    };
    list:any[]=[];
    params: any = {};
    showModal: boolean = false;
    activeKey: string = 'did';
}


// WEBPACK FOOTER //
// ./src/display/platform/DiDManager/Modules.State.ts